var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.684 2.562c.352.125.629.402.754.754.105.294.054.574.013.746-.04.176-.111.386-.184.605l-5.294 15.881c-.08.242-.156.469-.233.645-.072.166-.207.441-.486.616a1.245 1.245 0 01-1.098.112c-.308-.115-.496-.357-.6-.505a8.273 8.273 0 01-.359-.585L9.52 14.48 3.17 10.803c-.22-.128-.427-.248-.584-.359-.149-.104-.391-.292-.506-.6a1.245 1.245 0 01.112-1.098c.175-.279.45-.414.616-.486.176-.077.403-.153.645-.233l15.88-5.294c.22-.073.43-.143.606-.184.172-.04.452-.092.746.013zm-1.34 3.15l-4.814 14.44L11 14.055l8.344-8.342zM9.944 13L3.849 9.47l14.44-4.813L9.944 13z",
    fill: "currentColor"
  })));
}
export default SvgPaperplane;